import request from '@/util/request'

// 获取乡镇列表
export function getTownList (data, deptId = "") {
    return request({
        url: '/api/townList',
        data: data,
        method: 'post',
        headers: {
            deptId: deptId ? deptId : sessionStorage.getItem("deptId")
        }
    })
}


// 获取分类列表
export function getTypeList (data) {
    return request({
        url: '/api/typeList',
        data: data,
        method: 'post',
    })
}